export default __webpack_public_path__ + "static/media/04_photo.04497592.jpeg";